<template>
    <div class="py-2 mt-8 mb-4">
        <div
            class="flex justify-center gap-8 md:gap-12 px-6 tex-center text-center text-white"
            v-if="!hasEnded"
        >
            <template>
                <div>
                    <div class="mb-2">Days</div>
                    <div class="font-bold text-5xl">{{ days }}</div>
                </div>
                <div>
                    <div class="mb-2">Hours</div>
                    <div class="font-bold text-5xl">{{ hours }}</div>
                </div>
                <div>
                    <div class="mb-2">Minutes</div>
                    <div class="font-bold text-5xl">{{ minutes }}</div>
                </div>
                <div>
                    <div class="mb-2">Seconds</div>
                    <div class="font-bold text-5xl">{{ seconds }}</div>
                </div>
            </template>
        </div>
        <div class="text-2xl font-bold text-center mt-4">
            <template v-if="!hasEnded">
                REMAINING
            </template>
            <template v-else>
                Presale has finished
            </template>
        </div>
    </div>
</template>

<script>
import moment from "moment-timezone";

export default {
    props: {
        presale: {
            type: Object,
            required: false
        }
    },
    data: function() {
        return {
            endDate: moment(this.presale.end_date).tz(this.$website.timezone, true),
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            hasEnded: false,
            countdownIntervalId: null
        };
    },
    mounted() {
        this.updateCountdown();
        this.countdownIntervalId = setInterval(this.updateCountdown, 1000);
    },
    methods: {
        updateCountdown() {
            const currentDate = moment();
            const diff = moment(this.endDate)
                .tz(this.$website.timezone)
                .diff(currentDate);
            const duration = moment.duration(diff);
            this.days = Math.floor(duration.asDays());
            this.hours = duration.hours();
            this.minutes = duration.minutes();
            this.seconds = duration.seconds();
            this.hasEnded = this.seconds < 0 || this.minutes < 0 || this.hours < 0;
            if (this.hasEnded) {
                clearInterval(this.countdownIntervalId);
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.countdownIntervalId);
    }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/presale-count-down.vue